import { faCheck } from '@fortawesome/pro-solid-svg-icons/faCheck';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classnames from 'classnames';
import { FlexRow } from 'ui-components/components/flex/row';
import { Text, TextType } from 'ui-components/components/text';

import styles from './styles.module.less';

import type { ImportStep } from '../../types/types';

type StepDetectiveProps = {
  activeStepIndex?: number;
  steps: ImportStep[];
};

export const StepDetective = ({ activeStepIndex = 0, steps }: StepDetectiveProps) => {
  const isPrevious = (stepIndex: number) => {
    return activeStepIndex > stepIndex;
  };

  const isDone = (stepIndex: number) => {
    return !!steps[stepIndex]?.isDone;
  };

  const isCurrent = (stepIndex: number) => {
    return activeStepIndex === stepIndex;
  };

  const isLast = (stepIndex: number) => {
    const lastIndex = steps.length - 1;
    return stepIndex === lastIndex;
  };

  const isFirst = (stepIndex: number) => {
    return stepIndex === 0;
  };

  return (
    <ul className={styles['c-stepper']}>
      {steps.map((step, stepIndex) => {
        const isStepPrevious = isPrevious(stepIndex);
        const isStepDone = isDone(stepIndex);
        const isStepCurrent = isCurrent(stepIndex);
        const isStepFirst = isFirst(stepIndex);
        const isStepLast = isLast(stepIndex);

        const itemClassName = classnames(styles['c-stepper-item'], {
          [styles['c-stepper-item-first']]: isStepFirst,
          [styles['c-stepper-item-last']]: isStepLast,
          [styles['c-stepper-item-done']]: isStepDone,
          [styles['c-stepper-item-prev']]: isStepPrevious,
          [styles['c-stepper-item-current']]: isStepCurrent,
        });

        const circleClassName = classnames(styles.circle, {
          [styles.prev]: isStepPrevious,
          [styles.current]: isStepCurrent,
          [styles.done]: isStepDone,
        });

        const titleClassName = classnames(styles['c-stepper-title'], {
          [styles['c-stepper-title-prev']]: isStepPrevious || isStepDone,
        });

        const content = (
          <>
            <FlexRow className={circleClassName}>
              {isStepPrevious || isStepDone ? <FontAwesomeIcon className={styles['checkmark-icon']} icon={faCheck} /> : null}
            </FlexRow>
            <Text className={titleClassName} element='span' textType={TextType.Caption} value={step.title} />
          </>
        );

        return (
          <li key={step.id} className={itemClassName} data-testid={step.id}>
            {isStepFirst || isStepLast ? <div className={styles['c-stepper-item-wrapper']}>{content}</div> : content}
          </li>
        );
      })}
    </ul>
  );
};
